import { render, staticRenderFns } from "./CustomerProfile.vue?vue&type=template&id=2820560e&"
import script from "./CustomerProfile.vue?vue&type=script&lang=js&"
export * from "./CustomerProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports